<template lang="pug">
  form.form.education
    h3.form-title.text-center ส่วนที่ 2 :  ประวัติการศึกษาและทักษะต่างๆ

    .education-item(v-for="(item, index) in education")
      h4.form-subtitle(v-if="!item.default && item.level") {{ item.level }}
        button.education-remove(
          v-if="!item.default"
          @click="remove($event, index)"
        ) ลบ

      h4.form-subtitle(v-else) {{ item.title }}
        button.education-remove(
          v-if="!item.default"
          @click="remove($event, index)"
        ) ลบ

      .form-item
        .row
          .col-sm-4
            .row
              label.col-sm-4(
                :for="`level${index}`"
              ) ระดับการศึกษา

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="ระดับการศึกษา"
                  )
                    input.form-control(
                      :id="`level${index}`"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      type="text"
                      v-model="item.level"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-4
            .row
              label.col-sm-4.text-right(
                :for="`since${index}`"
              ) เข้าศึกษา

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="เข้าศึกษา"
                  )
                    input.form-control(
                      :id="`since${index}`"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      type="date"
                      v-model="item.since"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-4
            .row
              label.col-sm-5.text-right(
                :for="`to${index}`"
              ) สำเร็จการศึกษา

              .col-sm-7
                .form-group
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="สำเร็จการศึกษา"
                  )
                    input.form-control(
                      :id="`to${index}`"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      type="date"
                      v-model="item.to"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

      .form-item.has-bg
        .row
          .col-sm-4
            .row
              label.col-sm-4(
                :for="`institut${index}`"
              ) สถานศึกษา

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="ระดับการศึกษา"
                  )
                    input.form-control(
                      :id="`institut${index}`"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      type="text"
                      v-model="item.institut"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-4
            .row
              label.col-sm-4.text-right(
                :for="`fieldStudy${index}`"
              ) สาขาวิชา

              .col-sm-8
                .form-group
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="สาขาวิชา"
                  )
                    input.form-control(
                      :id="`fieldStudy${index}`"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      type="text"
                      v-model="item.field_of_study"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

          .col-sm-4
            .row
              label.col-sm-5.text-right(
                :for="`grade${index}`"
              ) เกรด / คะแนนเฉลี่ย

              .col-sm-7
                .form-group
                  validation-provider(
                    v-slot="{ errors, valid }"
                    rules="required"
                    name="สาขาวิชา"
                  )
                    input.form-control(
                      :id="`grade${index}`"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                      type="number"
                      v-model="item.grade"
                      @input="onChange"
                    )
                    span.invalid-feedback {{ errors[0] }}

    button.education-add(@click="generate") + เพิ่มระดับการศึกษา


    .form-footer
      .d-flex.justify-content-center
        button.back(@click="$store.commit('SET_STEP', 1)") กลับสู่ก่อนหน้า
        button.next(type="submit" @click="$store.commit('SET_STEP', 3)") บันทึกและไปขั้นต่อไป
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    users: [],
  }),

  computed: {
    ...mapState(['education'])
  },

  methods: {
    generate(){
      this.education.push({
        title: 'ระดับการศึกษา',
        level: '',
        start_year: '',
        end_year: '',
        institut: '',
        field_of_study: '',
        grade: '',
        default: false,
      });

      this.$store.commit('SET_EDUCATION', this.education)
    },

    remove(e, index){
      this.$delete(this.education, index)
      this.$store.commit('SET_EDUCATION', this.education)
      // e.target.parentNode.parentNode.parentNode.removeChild(e.target.parentNode.parentNode)
    },

    onChange() {
      this.$store.commit('SET_EDUCATION', this.education) 
    }
  },
}
</script>

<style lang="scss" scoped>
.education {
  &-item {
    margin-bottom: 4rem;
  }

  &-add {
    width: 100%;
    text-align: center;
    color: #0f4c98;
    font-size: 20px;
    line-height: 1;
    font-weight: 600;
    display: block;
    padding: 2rem 0;
    background: #f5f5f5;
    border: none;
    outline: none;
  }

  &-remove {
    position: absolute;
    right: 4rem;
    color: #fff;
    font-size: 18px;
    line-height: 1;
    border: none;
    padding: 0.5rem 1rem;
    background: #0f4c98;
    outline: none;
  }
}
</style>